<template>
  <section class="invoice-preview-wrapper">
    <b-card no-body class="invoice-preview-card">
      <b-badge v-if="userObjective" :variant="isObjectiveValid ? 'primary' : 'warning'" class="badge-glow">
        {{ isObjectiveValid ? 'Validé' : 'Non Validé' }}
      </b-badge>
      <div>

        <div class="m-2">
          <div class="card-header d-flex justify-content-between align-items-center">
            <div>
              <b-card-title>Objectif</b-card-title>
            </div>
            <b-form-select
                id="yearSelect"
                v-model="currentYear"
                size="sm"
                :options="yearOptions"

                class="budget-dropdown"
            />
          </div>
          <div v-if="!userObjective" class="alert-body">
            <b-alert variant="warning" show>
            <span><strong>Pas d'objectif effectué pour l'année {{
                currentYear ? currentYear.year : new Date().getFullYear()
              }} !</strong></span>
            </b-alert>

          </div>

          <div v-if="userObjective">
            <app-timeline>
              <app-timeline-item
                  v-for="(item, index) in signatureValidUser" :key="index"
                  :title="`${item.titre} ${item.users.firstName} ${item.users.lastName}`"
                  :subtitle="item.text"
                  :time="formatDate(item.dateCreate)" :variant=item.variant
              />
            </app-timeline>
          </div>
          <div class="d-flex demo-inline-spacing justify-content-end mt-3">

            <b-button
                v-if="userObjective"
                variant="outline-primary"
                @click="$router.push({ name: 'objectif_print', params: { id: userObjective.id, isRapport: 0 } })">

              <feather-icon icon="EyeIcon" class="mr-50"/>
              <span class="align-middle">Detail</span>
            </b-button>

            <b-button
                v-if="objectiveCanBeEdited"
                variant="outline-success"
                @click="$router.push({ name: 'objectif' , query: { year: currentYear }})"
            >
              <feather-icon icon="EditIcon" class="mr-50"/>
              <span class="align-middle">Editer</span>
            </b-button>
          </div>

        </div>

      </div>


    </b-card>
  </section>
</template>

<script>
import {BAlert, BBadge, BButton, BCard, BCardTitle, BDropdown, BDropdownItem, BFormSelect} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import {getUserObjectivesByYears} from '@/services/UserObjectiveService';
import {allYears} from '@/services/YearsService';
import Ripple from 'vue-ripple-directive';
import {getSetting} from "@/services/SettingService";
// import vSelect from 'vue-select'

export default {
  directives: {
    Ripple
  },
  components: {
    BFormSelect,
    BCard,
    AppTimeline,
    AppTimelineItem,
    BBadge,
    BButton,
    BAlert,
    // BDropdown,
    // BDropdownItem,
    BCardTitle,
    // vSelect,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      userObjective: null,
      currentYear: new Date().getFullYear(),
      years: [],
      signatureValidUser: [],
    };
  },
  computed: {
    isObjectiveValid() {
      return this.userObjective && this.userObjective.valid;
    },
    objectiveCanBeEdited() {
      return  !this.userObjective || (this.userObjective && (this.userObjective.status === 'PROPOSE' || this.userObjective.status === 'REJETE'));
    },
    yearOptions() {
      return this.years.map(year => ({
        value: year.year,
        text: `${year.year}`,
      }));
    },
  },
  watch: {
    currentYear(value) {
      this.fetchUserObjectiveData();
    }
  },
  methods: {


    formatDate(date) {
      if (!date) return '';
      if (Array.isArray(date)) {
        const [year, month, day] = date;
        return `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
      }
      if (typeof date === 'string') {
        const [year, month, day] = date.split('-');
        return `${day}-${month}-${year}`;
      }
      console.error('Invalid date format:', date);
      return '';
    },
    async fetchUserObjectiveData() {

      if (this.userData && this.currentYear) {
        try {
          // if (!response) return;

          this.userObjective = await getUserObjectivesByYears(this.userData.id, this.currentYear);

          if (!this.userObjective.id) return;

          this.signatureValidUser = []
          const { status, validHierachy: isValid, users, dateCreate, signatureObjective = [],dateValid, rejetHierachyn } = this.userObjective;

          this.addSignatureUser("Collaborateur :", users, true, dateCreate, "Objectifs proposés", "success");
          const n1 = signatureObjective.find(item => item.hierarchyN === 1);
          const n2 = signatureObjective.find(item => item.hierarchyN === 2);

          switch (status) {
            case 'PROPOSE':
              if (n1) this.addSignatureUser("Manager N°1 :", n1.users, false, null, "En attente de validation", "warning");
              break;
            case 'VALIDE_HIERARCHY_1':
              if (n1) {
                this.addSignatureUser("Manager N°1 :", n1.users, true, n1.confirmDate, "Objectifs validés", "success");
              }
              this.addSignatureUser("Collaborateur :", users, false, null, "En attente de validation finale", "warning");
              break;
            case 'TRANSMIT_HIERARCHY_2':
              if (n1) {
                this.addSignatureUser("Manager N°1 :", n1.users, true, n1.confirmDate, "Objectifs validés", "success");
              }
              if (n2) {
                this.addSignatureUser("Manager N°2 :", n2.users, false, null, "En attente de validation", "warning");
              }
              break;
            case 'VALIDE_HIERARCHY_2':
              if (n1) {
                this.addSignatureUser("Manager N°1 :", n1.users, true, n1.confirmDate, isValid ? "Objectifs validés" : "Objectifs rejetés", "success");
              }
              if (n2) {
                this.addSignatureUser("Manager N°2 :", n2.users, true, n2.confirmDate, "Objectifs validés", "success");
              }
              if (isValid) {
                this.addSignatureUser("Collaborateur :", users, false, null, "En attente de validation finale", "warning");
              } else {
                this.addSignatureUser("Manager N°1 :", n1?.users, false, null, "En attente de correction", "warning");
              }
              break;
            case 'REJETE':
              if (rejetHierachyn === 1) {
                this.addSignatureUser("Manager N°1 :", n1.users, false, n1.confirmDate, "Objectifs rejetés", "danger");
                this.addSignatureUser("Collaborateur :", users, false, null, "En attente de correction", "warning");
                break;
              }
              else if(rejetHierachyn===2) {
                if (n1) {
                  this.addSignatureUser("Manager N°1 :", n1.users, true, n1.confirmDate, "Objectifs validés ", "success");
                }
                if (n2) this.addSignatureUser("Manager N°2 :", n2.users, false, n2.confirmDate, "Objectifs rejetés", "danger");
                if (n1) this.addSignatureUser("Manager N°1 :", n1.users, false, null, "En attente de correction par le N et le N+1", "warning");
                break;
              }
              break;

            case 'VALIDE_COLLABORATEUR':  // <-- ici on ajoute la validation finale / clôture
              if (n1) {
                this.addSignatureUser("Manager N°1 :", n1.users, true, n1.confirmDate, isValid ? "Objectifs validés " : "Objectifs rejetés ", "success");
              }
               if (n2) {
                this.addSignatureUser("Manager N°2 :", n2.users, true, n2.confirmDate, "Objectifs validés ", "success");
              }
              this.addSignatureUser("Collaborateur :", users, true, dateValid, "Validation finale - Objectifs clôturés","success");
              break;
          }
        } catch (error) {
          console.error('Error fetching user objectives by year:', error);
        }
      }
    },
    addSignatureUser(titre, users, signature, dateCreate, text, variant) {
      if (!users) return;
      this.signatureValidUser.push({
        titre,
        users,
        signature,
        dateCreate,
        text,
        variant,
      });
    },
    async getAllYears() {
      try {
        this.years = await allYears();
        if (!this.currentYear && this.years.length) {
          this.currentYear = this.years[0].year;
        }
      } catch (error) {
        console.error('Error fetching years:', error);
      }
    },
  },
  async mounted() {
    await this.getAllYears();
    try {
      const response = await getSetting();
      if (response && response.yearObjective) {
        this.currentYear = response?.yearObjective?.year;
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      this.currentYear = this.years.length ? this.years[0].year : new Date().getFullYear();
    }
    await this.fetchUserObjectiveData();
  },
};
</script>

<style scoped>
.budget-dropdown {
  width: 80px;
  border: 1px solid #005cb9;
  border-radius: 0.357rem;
  background-color: #fff;
  font-size: 1rem;
  line-height: 1.45;
  color: #005cb9;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.budget-dropdown:focus,
.budget-dropdown:active {
  border-color: #7367f0;
  box-shadow: 0 0 0 0.2rem rgba(115, 103, 240, 0.2);
  outline: none;
}
</style>
